<template>
  <div>
    <div class="container">
      <CreateTitle :title="page_title"/>

      <div class="create">
        <loader :isLoading="is_request_in_progress"/>

        <div class="row">
          <div class="col-sm col-md-5">
            <img :src="image_data" alt="Add your company logo" width=80% height="auto">
          </div>

          <div class="col-sm col-md-7">
            <p class="company-info">
              Help people to recognize your company.
              Please submit your company logo. If not applicable, use establishment photo.
            </p>

            <div class="text-center">
              <input
                type="file"
                name="company-logo-file"
                id="company-logo-file"
                class="input-file"
                accept="image/jpeg, image/png"
                @change="previewImage"
              />
              <i class="fas fa-camera"></i>
              <label for="company-logo-file" id="upload-label-link">Upload your company logo</label>
            </div>

            <div class="text-center">
              <small v-if="error" data-type="message" class="form-text text-muted error-message"> {{ error }} </small>
              <button @click="submitPhoto()" type="submit" class="btn btn-primary">Next</button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/styles/form-style-1.css"

// import { mapGetters } from 'vuex'
// import { SET_PROFILE_PICTURE } from '@/store/mutations.type'

import CreateTitle from '@/components/common/CreateTitle'
import Loader from '@/components/common/Loader'

import { COMPANY_LOGO } from '@/api/constants/ImageAssets'
import { APIService } from '@/api/APIService'
// import { AuthService } from '@/api/AuthService'

const api = new APIService()
// const auth = new AuthService()
const assetImage = COMPANY_LOGO
const MAX_SIZE_PROFILE = 2097152

export default {
  components: {
    CreateTitle,
    Loader
  },
  data() {
    return {
      page_title: "Upload Your Company Logo",
      image_data: assetImage,
      error: '',
      is_request_in_progress: false,
    }
  },
  props: {
    companyId: String
  },
  mounted() {
    if(this.getProfilePicture){
      this.image_data = this.getProfilePicture
    }
  },
  methods: {
    previewImage: function(event) {
      this.error = ''
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        var file = input.files[0]
        if (file.type !== 'image/png' && file.type !== 'image/jpeg') {
          this.error = 'File type not supported. Select png or jpeg'
          return
        }
        if (file.size > MAX_SIZE_PROFILE) {
          this.error = 'Please upload image up to 2mb'
          return
        }
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.image_data" refers to the image_data of Vue component
          // Read image as base64 and set to image_data
          // this.$store.dispatch(SET_PROFILE_PICTURE, e.target.result)
          this.image_data = e.target.result
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(file)
      }
    },
    async submitPhoto() {
      try {
        this.is_request_in_progress = true
        if(this.image_data === assetImage) {
          this.error = 'Please submit a company logo to proceed'
          return
        }

        const fields = { image_url: this.image_data }
        const uploadImage = await api.uploadImage(fields)
        const companyLogo = { company_details: { company_logo: uploadImage.object_name } }
        this.updateCompanyDetails(companyLogo)
      } catch(err) {
        this.error = err
        this.is_request_in_progress = false
      }
    },
    async updateCompanyDetails(field) {
      try {
        const updateDetails = await api.updateCompanyProfile(this.companyId, field)
        if(updateDetails.statusCode === 200) this.redirectToPage()
        else {
          this.error = updateDetails.message
          this.is_request_in_progress = false
        }
      } catch(err) {
        this.error = err
        this.is_request_in_progress = false
      }
    },
    redirectToPage() {
      this.$router.push(`/create-profile/business/${this.companyId}/address`)
    }
  }
}
</script>

<style>
  @import '../../assets/styles/form-style-1.css';
</style>

<style scoped>
p {
  font-family: 'HKGrotesk-Light', Helvetica, Arial, sans-serif;
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 2em;
}
#upload-label-link {
  cursor: pointer;
}
label {
  font-weight: bold;
  color: #007bff;
  margin-bottom: 30px;
}

svg {
  color: #007bff;
  margin-right: 8px;
}

</style>



// WEBPACK FOOTER //
// src/containers/business_profile/CreateBusinessProfilePhoto.vue